export const MEDIA = {
  MAX_375: '@media screen and (max-width: 375px)',
  MAX_599: '@media screen and (max-width: 599px)',
  MAX_767: '@media screen and (max-width: 767px)',
  MAX_1239: '@media screen and (max-width: 1239px)',
  MAX_1239_LANDSCAPE:
    '@media screen and (max-width: 1239px) and (orientation: landscape)',
  MAX_1239_OR_LANDSCAPE:
    '@media screen and (max-width: 1239px), (hover: none) and (pointer: coarse) and (orientation: landscape)',
  MAX_1239_LANDSCAPE_TOUCH:
    '@media screen and (max-width: 1239px) and (orientation: landscape) and (hover: none) and (pointer: coarse)',
  MAX_1439: '@media screen and (max-width: 1439px)',
  MAX_1639: '@media screen and (max-width: 1639px)',
  MAX_1919: '@media screen and (max-width: 1919px)',

  MIN_375: '@media screen and (min-width: 375px)',
  MIN_600: '@media screen and (min-width: 600px)',
  MIN_768: '@media screen and (min-width: 768px)',
  MIN_1024: '@media screen and (min-width: 1024px)',
  MIN_1240: '@media screen and (min-width: 1240px)',
  MIN_1240_OR_LANDSCAPE:
    '@media screen and (min-width: 1240px), (hover: none) and (pointer: coarse) and (orientation: landscape)',
  MIN_1440: '@media screen and (min-width: 1440px)',
  MIN_1640: '@media screen and (min-width: 1640px)',
  MIN_1920: '@media screen and (min-width: 1920px)',

  TOUCH: '@media screen and (hover: none) and (pointer: coarse)',
  // https://setplexapps.atlassian.net/browse/FP-3367
  // Experimental solution for desktop touch devices with mouse
  NO_TOUCH: '@media screen and (hover: hover)',
} as const
export type MEDIA = (typeof MEDIA)[keyof typeof MEDIA]
